import * as React from "react";
import { Route } from "react-router-dom";

import SetupList from "../resources/registrations/SetupList";
import Logout from "../../components/Logout";

import { EmailAnnouncement } from "../../adminApp/resources/announcements/EmailAnnouncement";
import { InventoryActivityReport } from "../../managerApp/reports/inventory/InventoryActivityReport";

const adminRoutes = [
  <Route exact path="/logout" render={() => <Logout />} />,
  <Route path="/newYard" render={(props) => <SetupList {...props} />} />,
  <Route
    path="/emailAnnouncement"
    render={(props) => <EmailAnnouncement {...props} />}
  />,
  <Route
    path="/reportInventoryActivity"
    render={(props) => (
      <InventoryActivityReport
        resource="inventories"
        basePath="/inventories"
        {...props}
      />
    )}
  />,
];

export default adminRoutes;
